// Angular dependencies
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { ApiService } from '../core/upgraded-providers';

@Injectable()
export class SeasonsUsersRanksService {
    _destroySbj: Subject<void> = new Subject();

    constructor(
        private _apiSrv: ApiService
    ) {
    }

    async getRewards(user: string): Promise<any> {
        try {
            const { seasons, usersSeasons } = await this._apiSrv.get(`seasons/users/${ user }/ranks`, { });

            const seasonsMap = seasons.reduce((acc, season) => {
                acc[season.index] = season;

                return acc;
            }, {});

            const list  = usersSeasons.map(({ season, rank }) => {
                return {
                    rank,
                    page: Math.ceil(rank / 10),
                    season: seasonsMap[season]._id,
                    img: rewardsFp(rank, season), 
                    title: seasonsMap[season] && seasonsMap[season].title
                }
            });

            return {
                list
            };
        } catch (err) {
            throw err;
        }
    }
}

function rewardsFp(rank: number, season: number) {
    let reward = '';

    if (rank >= 1 && rank <= 3) {
        reward = `${ rank }`;
    }

    if (rank >= 4 && rank <= 10) {
        reward = '10';
    }

    if (rank >= 11 && rank <= 30) {
        reward = '30';
    }

    if (rank >= 31 && rank <= 50) {
        reward = '50';
    }

    if (rank >= 51 && rank <= 100) {
        reward = '100';
    }

    return `https://s3.amazonaws.com/static.screeps.com/seasons/season${ season }/rewards/${ reward }.png`;
}
